import { render, staticRenderFns } from "./AvgRespondTime.vue?vue&type=template&id=325c55f4&scoped=true&"
import script from "./AvgRespondTime.vue?vue&type=script&lang=js&"
export * from "./AvgRespondTime.vue?vue&type=script&lang=js&"
import style0 from "./AvgRespondTime.vue?vue&type=style&index=0&id=325c55f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c55f4",
  null
  
)

export default component.exports